const SkillData = {
  SkillItems: [
    {
      id: 1,
      iconName: 'lab la-html5',
      title: 'HTML5'
    },
    {
      id: 2,
      iconName: 'lab la-css3',
      title: 'CSS3'
    },
    {
      id: 3,
      iconName: 'lab la-js-square',
      title: 'JavaScript'
    },
    {
      id: 4,
      iconName: 'lab la-react', 
      title: 'React JS'
    },
    {
      id: 5,
      iconName: 'lab la-git-alt', 
      title: 'Git'
    },
    {
      id: 6,
      iconName: 'lab la-github', 
      title: 'GitHub'
    },
    {
      id: 7,
      iconName: 'lab la-gulp', 
      title: 'Gulp'
    },
    {
      id: 8,
      iconName: 'las la-code', 
      title: 'Markdown'
    }
  ]
}

export default SkillData